export const version = 'kunde-v1.20.0-SNAPSHOT-fa66354a4d9ffc519b97ea88aa39440dfe105795';